import React from 'react';
export function FinancialAmount({ value, currency = 'SAR', minimumFractionDigits = 2, className = '', ...props }) {
  const number = Number(value || 0);
  const formatted = new Intl.NumberFormat('en-US', { style: currency ? 'currency' : 'decimal', currency: currency || undefined, minimumFractionDigits, maximumFractionDigits: minimumFractionDigits }).format(number);
  return <span className={`tp-financial-number financial-number ${className}`} {...props}>{formatted}</span>;
}
export function DocumentReference({ children, className = '', ...props }) { return <span className={`document-reference ${className}`} {...props}>{children}</span>; }
